import { useSelector, useDispatch } from "react-redux";
import { BreadcrumbPortal } from "./ui/Breadcrumb";
import { matchReportUrl } from "../utils/helpers";
import ToastNotification from "./alerts/ToastNotification";
import {
    clearCompletedExportJobs,
    setShowExportToast,
} from "../slices/highVolumeSlice";

function SubHeader() {
    const path = window.location.pathname;
    const reportUrl = matchReportUrl(path);
    const dispatch = useDispatch();
    const { showExportToast, highVolumeGeneratingReport, exportJobs } =
        useSelector((state) => state.highVolume);

    // Separate completed/success jobs from in-progress jobs
    const allJobs = exportJobs || [];
    const completedJobs = allJobs.filter(
        (job) => job.status === "success" || job.status === "failed"
    );
    const inProgressJobs = allJobs.filter((job) => job.status === "progress");

    // A document download in flight (surfaced separately from report generation)
    const isDownloadingDocument = inProgressJobs.some(
        (job) => job.type === "download"
    );

    // Show completed jobs if any exist, otherwise show in-progress jobs
    const jobsToDisplay =
        completedJobs.length > 0 ? completedJobs : inProgressJobs;

    const handleCloseExportToast = () => {
        dispatch(setShowExportToast(false));
        dispatch(clearCompletedExportJobs());
    };

    const handleOnClick = () => {
        dispatch(setShowExportToast(true));
    };

    return (
        <div
            className="subheader"
            style={reportUrl ? { padding: "0px 48px" } : {}}
        >
            <div
                className={`breadcrumbs align-items-center header ${
                    reportUrl ? "container-report" : "container"
                }`}
            >
                <BreadcrumbPortal />
                <div className="generating-report-container">
                    {highVolumeGeneratingReport && (
                        <div className="d-flex fs align-items-center">
                            <div
                                className="cursor-pointer"
                                onClick={handleOnClick}
                            >
                                Generating report
                            </div>
                            <span className="loading-dots" aria-hidden="true">
                                <span>.</span>
                                <span>.</span>
                                <span>.</span>
                            </span>
                        </div>
                    )}
                    {isDownloadingDocument && (
                        <div className="d-flex fs align-items-center">
                            <div
                                className="cursor-pointer"
                                onClick={handleOnClick}
                            >
                                Downloading
                            </div>
                            <span className="loading-dots" aria-hidden="true">
                                <span>.</span>
                                <span>.</span>
                                <span>.</span>
                            </span>
                        </div>
                    )}
                    {showExportToast && jobsToDisplay.length > 0 && (
                        <ToastNotification
                            message="Report export started successfully!"
                            files={jobsToDisplay}
                            onClose={handleCloseExportToast}
                            reportUrl={reportUrl}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default SubHeader;
